import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { InputDialogData } from './input.dialog.component';
import { JustTime } from 'src/app/helpers/helpers';
import { HMTimes, JoiHMInputComponent } from '../joi-input/joi-hm-input.component';
import { DialogWrapperComponent } from '../wrappers/dialog-wrapper.component';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { openConfirmDeleteGetResult } from '../dialog.confirmDelete.component';
import { DatePickerComponent } from '../misc/date-picker.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { DialogPositionNumbers } from 'globals/store/dialog.selector.data';

@Component({
    selector: 'time-log-dialog',
    template: `
<dialog-wrapper
  [disabled]="!justTime"
  [successLabel]="'SAVE'"
  [dialogTitle]="'Log time'"
  [smallTitle]="true"
  [giveMeTwenty]="true"
  [titleHeight]="40"
  [showClose]="true"
  [deleteLeft]="data.delete"
  [data]="{ position: data.position, dialogRef: dialogRef }"
  (close)="close()"
  (submit)="submit()"
  (delete)="delete($event)"
>
  <joi-hm-input (timeChange)="changeTime($event)" [startingJustTime]="justTime" [minMinutes]="0"></joi-hm-input>
  <mat-form-field class="general">
    <textarea matInput cdkTextareaAutosize id="value" name="value" (keyup.enter)="submit()" [(ngModel)]="notes" [placeholder]="'Notes'"></textarea>

  </mat-form-field>
  <date-picker [pickedDate]="date" (onDateChange)="date = $event"></date-picker>
</dialog-wrapper>
  `,
    styles: [`
    joi-hm-input { display: inline-block; margin-bottom: 17px; flex-direction: column; }
    ::ng-deep time-log-dialog dialog-wrapper .title { font-size: 16px !important; font-weight: bold; }
    ::ng-deep time-log-dialog dialog-wrapper button.delete { margin: 0px !important; padding: 0px !important; }
  `],
    standalone: true,
    imports: [DatePickerComponent, MatButtonModule, MatFormFieldModule, JoiHMInputComponent, DialogWrapperComponent, FormsModule, MatInputModule],
})
export class TimeLogDialogComponent {
  timeLogData: InputDialogData
  time: string
  notes = ''
  justTime: JustTime
  date = new Date()

  constructor(
    public dialogRef: MatDialogRef<TimeLogDialogComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: TimeLogDialogData,
  ) { 
    // console.log({ data: jsonCopyObject(data) })
    if (data.notes) this.notes = data.notes
    if (data.time) {
      this.justTime = data.time
    }
    if (data.date) this.date = data.date

  }

  changeTime(times: HMTimes) {
    this.time = times.timeText
    this.justTime = times.justTime
  }

  close() {
    this.dialogRef.close(null)
  }

  submit() {
    const data: TimeLogDialogData = { notes: this.notes, time: this.justTime, date: this.date }
    this.dialogRef.close(data)
  }

  async delete(event) {
    const data = {
      title: "Delete logged time",
      para: "This action cannot be undone",
      dialog: this.dialog,
      rect: event.target.getBoundingClientRect(),
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.dialogRef.close({ delete: true })
  }

}

export interface TimeLogDialogData { // serves as both input and output data!
  notes?: string,
  time?: JustTime,
  id?: string
  delete?: boolean
  date?: Date
  position?: DialogPositionNumbers
}
